import { apiClient } from "../api"
import { DTO_SystemFleet, FleetParam } from "./types/fleets"

enum Fleet {
  FLEETS = '/fleets/',
  SYSTEM_FLEET = '/system/fleet/',
  SYSTEM_OWNER = '/system/owner/'
}

export const getAvailableFleets = () => {
  const ac = apiClient()
  const promise = ac.get(Fleet.FLEETS)
    .then(res => res.data)
  return promise
}

export const getFleets = (): Promise<DTO_SystemFleet[]> => {
  const ac = apiClient()
  const promise = ac.get(Fleet.SYSTEM_FLEET)
    .then(res => res.data)
  return promise
}

export const createFleet = (data: FleetParam): Promise<DTO_SystemFleet> => {
  const ac = apiClient()
  const promise = ac.post(Fleet.SYSTEM_FLEET, {
    ...data
  }).then(res => res.data)
  return promise
}

export const updateFleet = (id: number, data: FleetParam): Promise<DTO_SystemFleet> => {
  const ac = apiClient()
  const promise = ac.patch(`${Fleet.SYSTEM_FLEET}${id}/`, {
    ...data
  }).then(res => res.data)
  return promise
}

export const deleteFleet = (id: number): Promise<void> => {
  const ac = apiClient()
  const promise = ac.delete(`${Fleet.SYSTEM_FLEET}${id}/`)
    .then(res => res.data)
  return promise
}

export const addMobileToFleet = (fleetid: number, mobileid: number) => {
  const ac = apiClient()
  const promise = ac.post(Fleet.SYSTEM_OWNER, {
    fleetid, mobileid
  }).then(res => res.data)
  return promise
}

export const removeMobileFromFleet = (ownerid: number) => {
  const ac = apiClient()
  const promise = ac.delete(`${Fleet.SYSTEM_OWNER}${ownerid}/`)
    .then(res => res.data)
  return promise
}
